import "./Print.less";
import React from "react";
import TamgaImg from "../../../assets/img/invoice/tamga.png";
import logo from "../../../assets/img/invoice/mainLogo.jpg";
import {MailOutlined, PhoneOutlined, EnvironmentOutlined} from '@ant-design/icons';
import { getDateTime } from "../../../utils/format";


export const InvoicePrintDocument = ({invoice, billing}) => {
  const date = [
    {name: "Эхлэх огноо:" , date: getDateTime(invoice?.createdAt)},
    {name: "Дуусах огноо:" , date:getDateTime(invoice?.dueDate)},
    {name: "Нэхэмилсэн огноо:" , date: getDateTime(invoice?.updatedAt)},
  ]
  const formatCurrency = (currency) => {
    let formetedCurrency = Number(currency)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    return formetedCurrency;
  };
  
  return (
    <div className="document_container">
      <div className="logo_container">
        <img alt="Лого" src={logo} />
      </div>
      <div className="general_inf">
          <span>Хэнд:</span>
          <p className="name">Дөлгөөнбаяр.М</p>
          <div>
            {[
              {icon: <MailOutlined />, value: "info@renew.mn"},
              {icon: <PhoneOutlined /> , value: "9509-6446"},
              {icon: <EnvironmentOutlined />, value: "УБ, БЗД, 14-р хороо"}
            ].map((el,i) => {
              return (
                <div key={i} className="item_container">
                  {el?.icon}
                  <p>{el?.value}</p>
                </div>
              )
            })}
          </div>
      </div>
      <div className="title_container">
        <h1>НЭХЭМЖЛЭХ</h1>
        <div className="code"><span>Дугаар:</span> <p>{invoice?.code}</p></div>
      </div>
      <div className="date_container"> 
        {date?.map((el,i) => {
          return (
            <div key={i} className="date_item">
              <span>{el?.name}</span>
              <p>{el?.date}</p>
              </div>
          )
        })}
      </div>
      <div className="main" >
       <div className="table_container"> 
        <tr className="table_header">
            <th>Үйлчилгээний төрөл</th>
            <th>Тоо хэмжээ</th>
            <th>НӨАТ-гүй дүн</th>
          </tr>
        {billing?.[0]?.invoiceSub?.map((el,i) => {
          return(
            <tr key={i}>
            <td><span>0{i + 1}</span> <p className="name">{el?.serviceType}</p></td>
            <td><p className="count">ш {el?.count}</p></td>
            <td><p className="amount">₮ {formatCurrency(el?.amount)}</p></td>
          </tr>
          )
        })}
       </div>
       <div >
          <div className="total_amount_container">
          <div className="total_amount_item"> <span>Нийт дүн /НӨАТ-гүй/ </span> <p>₮</p><p>{formatCurrency(invoice?.actualAmount)}</p></div>
          <div className="total_amount_item"> <span>НӨАТ 10% </span> <p>₮</p><p>{formatCurrency(invoice?.tax)}</p></div>
          </div>
            <div className="bank_acount_inf">
              <div>
              {[
                  {name: "Банк: " , value: "Худалдаа Хөгжлийн Банк"},
                  {name: " Дансны нэр: " , value: "Пик Пак ХХК"},
                  {name: "Данс: ", value: "499042000"},
                  {name: "Гүйлгээний утга: ", value: invoice?.code}
                ].map((el,i) => {
                  return (
                  <div key={i} className="bank_acount_item">
                  <p className="name">{el?.name}</p>
                  <p className="value">{el?.value}</p>
                </div>
              )
            })}
          </div>
          <div className="seal_section" >
           <div className="total_amount">
           <p>Нийт дүн /НӨАТ-тай/</p>
            <p className="total_price">{formatCurrency(invoice?.amount)}</p>
           </div>
           <img alt="Тамга" src={TamgaImg}/>
          </div>
        </div>
          <div className="main_inf">
          {[
              {icon: <MailOutlined />, value: "finance@pickpack.mn"},
              {icon: <PhoneOutlined /> , value: "7777-6090"},
              {icon: <EnvironmentOutlined />, value: "УБ, СБД, 1-р хороо, Централ Парк Тауэр оффис, 14 давхар"}
            ].map((el,i) => {
              return (
                <div key={i} className="item_container">
                  {el?.icon}
                  <p>{el?.value}</p>
                </div>
              )
            })}
          </div>
          <div className="dividers">
            <div className="blue"/>
            <div className="grey"/>
            <div className="blue"/>
          </div>
       </div>
      </div>
      </div>
  )
}
